import { render } from "./BasketIcon.vue?vue&type=template&id=500456af"
import script from "./BasketIcon.vue?vue&type=script&lang=js"
export * from "./BasketIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__